import angular from 'angular';
import '../core/data-access/peppol.data-access.js';

(function() {
    'use strict';
    angular.module('app.principal').factory('PeppolSvc', PeppolSvc);

    PeppolSvc.$inject = ['PeppolDA'];

    /* @ngInject */
    function PeppolSvc(PeppolDA) {
        var exports = {

            getPeppolTypeIdentifierByCountry:getPeppolTypeIdentifierByCountry,
        };

        return exports;

        function getPeppolTypeIdentifierByCountry(country) {
            return PeppolDA.getPeppolTypeIdentifierByCountry(country);
        }

    }
})();
